import type { AspectPresenceResolver } from '../archetypes/aspectPresence';
import { hasOwnGlyph, readOwnSphereGlyph } from './sphereGlyph';

const VISUAL_PROPERTIES: ReadonlySet<string> = new Set(['glyph', 'glyph_color']);

/**
 * ID-3 for `center_glyph`: the visual is filled by an own glyph, an own valid colour, or a picture
 * in the `avatar` slot. A `glyph_kind` alone never counts. The three properties are `hidden`, so
 * `fillable` is set explicitly: the Identity control can always fill an empty visual.
 *
 * When properties are withheld from the viewer, we cannot determine fillability from the visible
 * facts, so `fillable` is false to avoid reporting "empty and needs attention" for a state we
 * cannot see.
 */
export const centerGlyphPresenceResolver: AspectPresenceResolver = (facts, base) => {
  const filled = hasOwnGlyph(readOwnSphereGlyph(facts.values)) || facts.filledSlots.has('avatar');
  return {
    valueState: filled ? 'filled' : 'empty',
    evaluatedProperties: base.evaluatedProperties.filter((n) => VISUAL_PROPERTIES.has(n)),
    fillable: !filled && !base.hasWithheld,
    hasWithheld: base.hasWithheld,
  };
};
